import MenuItem from "./MenuItem";
import {
  getCategoryDisplay,
  LEFT_CATEGORIES,
  RIGHT_CATEGORIES,
  getColumnEntries,
} from "../../utils/menuUtils";

function MenuColumn({ category, items, image, language }) {
  const displayCategory = getCategoryDisplay(category, language);

  return (
    <div className="menu-section">
      {image && <img src={image} alt={displayCategory} />}
      <h3 className="menu-category-heading">{displayCategory}</h3>
      <div className="menu-item-list">
        {items.map((item) => (
          <MenuItem
            key={item.code || item.nameVn}
            name={language === "en" ? item.nameEn : item.nameVn}
            price={item.price}
          />
        ))}
      </div>
    </div>
  );
}

function MenuSection({ grouped, language }) {
  const leftColumnEntries = getColumnEntries(LEFT_CATEGORIES, grouped);
  const rightColumnEntries = getColumnEntries(RIGHT_CATEGORIES, grouped);

  return (
    <div className="menu-content">
      <div className="menu-col">
        {leftColumnEntries.map(([category, { image, items }]) => (
          <MenuColumn
            key={category}
            category={category}
            items={items}
            image={image}
            language={language}
          />
        ))}
      </div>
      <div className="menu-col menu-col--right">
        {rightColumnEntries.map(([category, { image, items }]) => (
          <MenuColumn
            key={category}
            category={category}
            items={items}
            image={image}
            language={language}
          />
        ))}
      </div>
    </div>
  );
}

export default MenuSection;
